<template>
  <APEXChart v-if="!!chartModule" :options="options" :series="series" :width="width" :height="height" :type="type" />
</template>

<script>
import { Chart } from "@/modules/chart";

export default {
  name: "Chart",

  data() {
    return {
      chartModule: null,
      isLoading: true,
    };
  },

  props: {
    data: {
      type: Object,
      required: true,
      default: () => null,
    },
  },

  mounted() {
    this.chartModule = new Chart(this.data);
  },

  computed: {
    /**
     * Get charts object
     * @return {Object}
     */
    options() {
      return this?.chartModule?.options;
    },

    /**
     * Get series object
     * @return {Array}
     */
    series() {
      return this?.chartModule?.series;
    },

    /**
     * Get type
     * @return {String}
     */
    type() {
      return this?.chartModule?.type;
    },

    /**
     * Get type
     * @return {String}
     */
    width() {
      return this?.chartModule?.options?.chart?.width;
    },

    /**
     * Get type
     * @return {String}
     */
    height() {
      return this?.chartModule?.options?.chart?.height;
    },
  },
};
</script>
<style src="./styles.scss" lang="scss" scoped></style>
